// import './App.css';
// import { ThemeProvider } from '@mui/material/styles';
// import theme from './theme/theme';
// import { Routes, Route, useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';
// import axios from './routes/axios';

// import Navbar from './views/navBar';
// import Footer from './views/footer';
// import routes from './routes/routes';
// import ProtectedRoute from './routes/protectedRoute'; // create this file

// function App() {
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Axios interceptor for expired token
//     axios.interceptors.response.use(
//       (response) => response,
//       (error) => {
//         if (error.response?.status === 401) {
//           localStorage.removeItem("token");
//           navigate("/login");
//         }
//         return Promise.reject(error);
//       }
//     );
//   }, [navigate]);

//   return (
//     <ThemeProvider theme={theme}>
//       <Navbar />

//       <Routes>
//         {routes.map((route, index) => {
//           // if route is protected, wrap it
//           if (route.protected) {
//             return (
//               <Route
//                 key={index}
//                 path={route.path}
//                 element={<ProtectedRoute>{route.element}</ProtectedRoute>}
//               />
//             );
//           }
//           return <Route key={index} path={route.path} element={route.element} />;
//         })}
//       </Routes>

//       <Footer />
//     </ThemeProvider>
//   );
// }

// export default App;


import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
import { Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import { useState, useEffect } from "react";

import customerRoutes from './routes/routes';
import adminRoutes from './routes/adminRoutes';
import ProtectedRoute from './routes/protectedRoute';

import CustomerLayout from './component/layouts/CustomerLayout';
import AdminLayout from './component/layouts/AdminLayout';

function App() {

   const [role, setRole] = useState(localStorage.getItem("role"));

  useEffect(() => {
    const handleStorageChange = () => {
      setRole(localStorage.getItem("role"));
    };

    // listen for login updates
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("auth:updated", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("auth:updated", handleStorageChange);
    };
  }, []);

  const routes = role === "admin" ? adminRoutes : customerRoutes;
  const Layout = role === "admin" ? AdminLayout : CustomerLayout;

  console.log("routes",routes );

  return (
   <ThemeProvider theme={theme}>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              // If route is protected
              route.protected ? (
                <ProtectedRoute allowedRole={route.role}>
                  <Layout>{route.element}</Layout>
                </ProtectedRoute>
              ) : (
                // Public route (no protection)
                <Layout>{route.element}</Layout>
              )
            }
          />
        ))}
      </Routes>
    </Suspense>
</ThemeProvider>

  );
}

export default App;
